<span>
  @if (isUnread) {
    <rt-dot color="unread" margin-right-small-x />
  }
  <ng-content />
  @if (typeof count === 'string' || $any(count) > 0) {
    <rt-badge margin-left-small-x [color]="countColor" [text]="count" />
  }
</span>

@if (hrefTarget && href) {
  <a [href]="href" target="{{ hrefTarget }}"></a>
}
@if (!hrefTarget && href) {
  <a [href]="href"></a>
}
